module.exports = __webpack_public_path__ + "img/uk.84b3e9f4.svg";